import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class PaginatorIntl extends MatPaginatorIntl {
  changes = new Subject<void>();

  itemsPerPageLabel = $localize`:@@itemsPerPageLabel:Items per page`;
  nextPageLabel = $localize`:@@nextPageLabel:Next page`;
  previousPageLabel = $localize`:@@previousPageLabel:Previous page`;
  firstPageLabel = $localize`:@@firstPageLabel:First page`;
  lastPageLabel = $localize`:@@lastPageLabel:Last page`;
  ofLabel = $localize`:@@ofLabel:of`;

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return '0 ' + this.ofLabel + ' ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' ' + this.ofLabel + ' ' + length;
  };
}
